var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showInfo
    ? _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.showInfo,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showInfo = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "infoWrap" },
            [
              _c(
                "el-form",
                {
                  ref: "refForm",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.formRules,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "logistic_business_id",
                        label: "集配中心",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            placeholder: "请选择集配中心",
                            disabled: _vm.formData.id ? true : false,
                          },
                          model: {
                            value: _vm.formData.logistic_business_id,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData,
                                "logistic_business_id",
                                $$v
                              )
                            },
                            expression: "formData.logistic_business_id",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "fullname", label: "区域经理" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入账号" },
                        model: {
                          value: _vm.formData.fullname,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "fullname", $$v)
                          },
                          expression: "formData.fullname",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "mobile", label: "电话" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入电话" },
                        model: {
                          value: _vm.formData.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "mobile", $$v)
                          },
                          expression: "formData.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择管辖区域", prop: "area_list" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.areaList,
                          props: _vm.props,
                          clearable: "",
                          filterable: "",
                        },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.formData.area_list,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "area_list", $$v)
                          },
                          expression: "formData.area_list",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择城市仓", prop: "logistics_ids" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "选择城市仓",
                            filterable: "",
                            multiple: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.formData.logistics_ids,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "logistics_ids", $$v)
                            },
                            expression: "formData.logistics_ids",
                          },
                        },
                        _vm._l(_vm.tdcList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name,
                              value: item.id,
                              filterable: "",
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "state" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "state", $$v)
                            },
                            expression: "formData.state",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("启用"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("禁用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showInfo = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitFrom },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }